import { createFileRoute } from "@tanstack/react-router";
import { SeriesRecommendationsPage } from "@/modules/SeriesDetails";

export const Route = createFileRoute(
  "/_default/series/$series/recommendations",
)({
  component: SeriesRecommendationsPage,
});
